import {SpeakerNumber, TopicMatch} from '@store/call-card/CallCard.types';
import {List, Map} from 'immutable';
import {Color, PctDouble, Seconds} from '@store/@types/util';
import './NarrowTranscript.sass';
import {TopicId} from '@store/topic-keyword/TopicKeyword.types';
import {MiniSpeakerNumber} from '@components/call-card/CallSpeaker.utils';

export function combineMatchesByLine(
  matches: Map<TopicId, List<TopicMatch>>,
  activeTopics: Map<TopicId, Color>
) {
  return (
    matches
      // Only show matches for active topics
      .filter((_, topicId) => activeTopics.has(topicId))
      .toList()
      .flatten(1)
      // group matches on the same transcript chunk
      .groupBy(m => m.startTime)
      // Sort by time so transcript appears in order
      .sortBy((_, startTime) => startTime)
  );
}

export interface MatchLocation {
  color: Color;
  startTimePct: PctDouble;
  speakerNumber: SpeakerNumber;
}

export function combineMatchesBySpeaker(
  matches: Map<TopicId, List<TopicMatch>>,
  activeTopics: Map<TopicId, Color>,
  duration: Seconds
): Map<SpeakerNumber, List<MatchLocation>> {
  return (
    matches
      // Only show matches for active topics
      .filter((_, topicId) => activeTopics.has(topicId))
      // Sort by recently added to active topics
      .sortBy((_, topicId) => activeTopics.keySeq().findIndex(t => topicId === t))
      .toList()
      // Flatten all matches into a single list
      .flatten(1)
      // Map to MatchLocation format
      .map(match => ({
        color: activeTopics.get(match.id)!,
        startTimePct: (match.startTime / duration) * 100,
        speakerNumber: match.speakerNumber,
      }))
      // Duplicate matches for the mini speaker track
      .flatMap(match => List([match, {...match, speakerNumber: MiniSpeakerNumber}]))
      // Group by speaker number
      .groupBy(match => match.speakerNumber)
  );
}

export function boldMatchText(chunk: string, matches: List<TopicMatch>) {
  for (const match of matches) {
    chunk = chunk.replaceAll(match.word, `<mark>${match.word}</mark>`);
  }
  return chunk;
}
